import type { ReactNode } from "react";
import { IconArrowLeft } from "@tabler/icons-react";
import AuthSplitLayout from "../../../../routes/auth-split-layout";
import { Heading, Text } from "../../../../../../components/common/typography";
import { StepProgress } from "../../../../../../components/common/step-progress";

interface RegisterWizardLayoutProps {
  title: string;
  subtitle?: string;
  /** When provided, renders the 3-pill progress bar. Step index is 1-based. */
  progress?: { current: number; total: number };
  onBack?: () => void;
  children: ReactNode;
}

export function RegisterWizardLayout({
  title,
  subtitle,
  progress,
  onBack,
  children,
}: RegisterWizardLayoutProps) {
  return (
    <AuthSplitLayout>
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          aria-label="Back"
          className="-mx-4 inline-flex h-12 w-full items-center self-start rounded-lg px-4 text-textBody hover:text-textDark"
        >
          <IconArrowLeft size={32} />
        </button>
      ) : null}

      <div className="flex w-full flex-col items-start gap-6">
        <Heading variant="h2" tone="dark">
          {title}
        </Heading>
        {subtitle ? (
          <Text variant="body" tone="body">
            {subtitle}
          </Text>
        ) : null}
        {progress ? (
          <StepProgress
            total={progress.total}
            current={progress.current}
            aria-label="Sign-up progress"
          />
        ) : null}
      </div>

      {children}
    </AuthSplitLayout>
  );
}

export default RegisterWizardLayout;
